<template>
    <div class="my-4 text-center">
        <VueRecaptcha v-if="!hasErrors" :sitekey="siteKey"
            @verify="verifyMethod"
            @expired="expiredMethod"
            @render="renderMethod"
            @error="errorMethod"
            :size="getRecaptchaSize"
            :language="'en'">
        </VueRecaptcha>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { VueRecaptcha } from 'vue-recaptcha';

const props = defineProps({
    invisible: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['recaptchaValueChange']);

const siteKey = process.env.MIX_RECAPTCHA_SITE_KEY;
const hasErrors = ref(false);
const isValid = ref(false);

function emitMethodToParent() {
    emit('recaptchaValueChange', hasErrors.value || isValid.value);
}

function verifyMethod(token) {
    isValid.value = true;
    emitMethodToParent();
}

function expiredMethod() {
    isValid.value = false;
    emitMethodToParent();
}

function renderMethod() {
}

function errorMethod() {
    hasErrors.value = true;
    emitMethodToParent();
}

const getRecaptchaSize = computed(() => {
    return props.invisible ? 'invisible' : 'normal';
});
</script>

<style scoped>

</style>
